import styled from 'styled-components'

export const Button = styled.button`
  background: #FFFFFF;
  border-color: #FFFFFF;
  border-radius: 3px;
  color: #000;
  height: 50px;
  display: block;
  width: 100%;
  text-align: center;
  &[disabled] {
    opacity: .3;
  }
`
